import React from 'react';
import { __ } from '@wordpress/i18n';
import { H2, P } from '../../../../ui/style';
import ThankYouButton from '../../../../components/util/thank-you-button/thank-you-button';

const Congratulations = () => {
	return (
		<div>
			<H2>{__('Ta-ta-da ', 'astra-sites')}</H2>
			<P mb2 i>{__('Congratulations — Your website is ready 🎉', 'astra-sites')}</P>

			<ThankYouButton after='dashicons-arrow-right-alt' gray large mb1>{__('Let\'s customize it now', 'astra-sites')}</ThankYouButton>
		</div>
	)
}

export default Congratulations;
